module.exports = __webpack_public_path__ + "img/begin_white.7fed24ac.svg";